<template>
  <div/>
</template>
<script>

import { noop } from 'lodash';
import { getQueryVariable, goToFirstValidRoute } from '@/utils/helpers';

export default {
  async mounted() {
    try {
      this.$store.dispatch('user/loginByQrCode', getQueryVariable('auth_code'))
        .then(() => { goToFirstValidRoute(this.$router); })
        .catch(noop);
    } catch (err) {
      window.console.error(err);
    } finally {
      this.isLoggingIn = false;
    }
  },
};
</script>
